"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutManager = void 0;
class TimeoutManager {
    constructor() {
        this._timers = {};
    }
    setTimeout(key, ...args) {
        this.clearTimeout(key);
        this._timers[key] = window.setTimeout.apply(null, args);
        return this._timers[key];
    }
    clearTimeout(key) {
        const timerHandle = this._timers[key];
        if (timerHandle) {
            window.clearTimeout(timerHandle);
        }
    }
    clearAllTimeouts() {
        Object
            .keys(this._timers)
            .forEach((key) => this.clearTimeout(key));
    }
}
exports.TimeoutManager = TimeoutManager;
//# sourceMappingURL=timeout-manager.js.map